
import { getSession } from "next-auth/react";
import bondTransactionTypeHandler from "./bond-transaction-type-handler";
import vesselDataFormLoad from "./vesselDataFormLoad";
const bondTransactionHandler = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata,formData } = event;
    const session: any = await fetchUser();
    const API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL; 
    let visibledata : any;
    let vesselData : any;
    let formattedBonds: any;

    visibledata = await bondTransactionTypeHandler(event);

    if (["line", "location", "vessel", "voyageNumber"].includes(event.modifiedField)) {
        vesselData = await vesselDataFormLoad(event);
    }
    const data= {
        layoutChanged: false,
        dataChanged: true,
        newFormData: {
            user: {solidManyToOneLabel: session?.user?.user?.email, solidManyToOneValue: session?.user?.user?.id}
        }
    }
    const mergedData = {
        layoutChanged: visibledata?.layoutChanged || data.layoutChanged || false,
        dataChanged: data.dataChanged || visibledata?.dataChanged || vesselData.dataChanged ||  false,
        newFormData: { 
            ...data.newFormData, 
            ...visibledata?.newFormData,
            ...vesselData?.newFormData
        },
        newLayout: visibledata?.newLayout || vesselData?.newLayout || undefined
    };
    return mergedData

};
const fetchUser = async () => {
    let session: any = await getSession();
    return session;
}

export default bondTransactionHandler;
